import { inboxReducer } from "./inbox.reducer";
import { groupsReducer } from "./groups.reducer";
import { brandProfileReducer } from "./brandProfile.reducer";
import { themeSettingsReducer } from "./themeSettings.reducer";
import { customerSurveyReducer } from "./customerSurvey.reducer";
import { userPermissionsReducer } from "./userPermissions.reducer";
import { surveyQuestionsReducer } from "./surveyQuestions.reducer";
import { brandPerformanceReducer } from "./brandPerformance.reducer";
import { archivedQuestionsReducer } from "./archivedQuestions.reducer";
import { sharedConsumerResponsesReducer } from "./consumerResponses.reducer";
import { individualStoreProfileReducer } from "./individualStoreProfile.reducer";
import { individualGroupProfileReducer } from "./individualGroupProfile.reducer";
import { individualStorePerformanceReducer } from "./individualStorePerformance.reducer";
import { individualGroupPerformanceReducer } from "./individualGroupPerformance.reducer";
import { marketingSalesReducer } from "./marketingSales.reducer";
import { campaignMetricsReducer } from "./campaignMetrics.reducer";
import { changeSurveyPreferencesReducer } from "./changeSurveyPreferences.reducer";
import { marketingAttributionReducer } from "./marketingAttribution.reducer";
import { processedMarketingAttributionReportReducer } from "./processedMarketingAttributionReport.reducer";
import { brandConfigurationReducer } from "./brandConfiguration.reducer";

// eslint-disable-next-line
export default {
  inboxReducer,
  groupsReducer,
  brandProfileReducer,
  themeSettingsReducer,
  customerSurveyReducer,
  marketingSalesReducer,
  userPermissionsReducer,
  campaignMetricsReducer,
  surveyQuestionsReducer,
  brandPerformanceReducer,
  archivedQuestionsReducer,
  brandConfigurationReducer,
  individualStoreProfileReducer,
  individualGroupProfileReducer,
  sharedConsumerResponsesReducer,
  individualStorePerformanceReducer,
  individualGroupPerformanceReducer,
  changeSurveyPreferencesReducer,
  marketingAttributionReducer,
  processedMarketingAttributionReportReducer,
};
